import { parseLoginErrors } from './parseError';
import { utils } from './utils';
import RegisterTelmexTask from '../../requests/tasks/user/RegisterTelmexTask';
import RequestManager from '../../requests/RequestManager';
import { paywayConfirm } from '../../requests/loader';
import SetTermsAndConditionsTask from '../../requests/tasks/user/SetTermsAndConditionsTask';
import { modifyUser } from '../../requests/loader';
import {GA4} from 'src/utils/trackers/GA4';

const register = (userDetectWS, email) => {
    let response = {
        success: false,
        response: {}
    };
    const request = utils.decomposeUrl(userDetectWS.url);
    request.params = Object.assign({}, requets.params, {
        email,
        accepterms: 1
    });
    const registerTask = new RegisterTelmexTask(request.uri, request.params);
    return new Promise((resolve, reject) => {
        RequestManager.addRequest(registerTask).then((resp) => {
            const { status = undefined } = resp;
            response.success = Number(status) === 0;
            response.response = resp;

            if (!response.success) {
                response.error = parseLoginErrors(resp);
            }

            resolve(response);
        }).catch((err) => {

            response = {
                success: false,
                response: err
            };

            reject(response);
        });
    });
};

const activate = (userDetectWS) => {
    let response = {
        success: false,
        response: {}
    };
    const request = utils.decomposeUrl(userDetectWS.url);
    return new Promise(
        (resolve, reject) => {
            paywayConfirm('services/payway/confirm', request.params).then((resp) => {
                response.success = !(resp.errors || !resp.response || resp.response === 'error');
                response.response = resp;
                if (!response.success) {
                    // TODO checar este parseo
                    response.error = parseLoginErrors(resp);
                }
                resolve(response);
            }).catch((err) => {
                response = {
                    success: false,
                    response: err
                };

                reject(response);
            });
        }
    );
};

const getMailFake = (user) => {
    const {userDetectWS: {ip : ipAdress = '0.0.0.0'}} = user
    const makeid = (length) => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };
    return `${ipAdress}_${makeid(4)}@cv.com`
};

const accept = (userDetectWS) => {
    let response = {
        success: false,
        response: {}
    };
    const request = utils.decomposeUrl(userDetectWS.url);
    const setTermsAndConditionsTask = new SetTermsAndConditionsTask(request.uri, request.params);
    return new Promise((resolve, reject) => {
        RequestManager.addRequest(setTermsAndConditionsTask).then((resp) => {
            const { status = undefined } = resp;
            response.success = Number(status) === 0;
            response.response = resp;

            if (!response.success) {
                response.error = parseLoginErrors(resp);
            }
            resolve(response);
        }).catch((err) => {
            response = {
                success: false,
                response: err
            };
            reject(response);
        })
    });

};

const sendGA4Metric = (user_id, parent_id) => {
    const gA4 = new GA4();
    gA4.sendRegisterIPTelmexEvent(user_id, parent_id);
}

const registerWithoutMail = (userDetectWS, user) => {
    let response = {
        success: false,
        response: {}
    };
    const request = utils.decomposeUrl(userDetectWS.url);
    request.params = Object.assign({}, request.params, {
        email: getMailFake(user),
        accepterms: 1
    });
    const registerTask = new RegisterTelmexTask(request.url, request.params);
    return new Promise((resolve, reject) => {
        RequestManager.addRequest(registerTask).then((resp) => {
            const { status = undefined } = resp;
            response.success = Number(status) === 0;
            response.response = resp;
            if (!response.success) {
                response.error = parseLoginErrors(resp);
            }
            if (response.data) {
                const {user_id, parent_id} = response.data;
                sendGA4Metric(user_id, parent_id);
            }
            resolve(resp);
        }).catch((err) => {
            response = {
                success: false,
                response: err
            };
            reject(response);
        })
    });
};


const uptateUserPassword = (params) => {
    let response = {
        success: false,
        response: {}
    };

    return new Promise((resolve, reject) => {
        modifyUser(params, 'POST').then((resp) => {
            const { status = undefined } = resp;
            response.success = Number(status) === 0;
            response.response = resp;

            if (!response.success) {
                response.error = parseLoginErrors(resp);
            }

            resolve(resp);
        }).catch((err) => {

            response = {
                success: false,
                response: err
            };
    
            reject(response);
        });
    })
};


/**
 * Main export
 */
export const iptelmex = {
    register,
    activate,
    accept,
    registerWithoutMail,
    uptateUserPassword
};



// WEBPACK FOOTER //
// ./src/AAF/Auth/iptelmex.js